import { Grid, TextField } from "@mui/material";
import React from "react";
import GoogleAddressSelect from "../patient/GoogleAddressSelect";
import { MuiTelInput } from "mui-tel-input";

const CreateOrganization = ({ organization, setOrganization, errors }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setOrganization((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <>
      <div className="add-edit-patient-container">
        <Grid container spacing={2}>
          <Grid xs={12} item>
            <h6 className="add-edit-patient-sub-header">
              Organization Details
            </h6>
          </Grid>
          <Grid xs={12} item>
            <TextField
              fullWidth
              value={organization?.name}
              name="name"
              label="Name"
              variant="outlined"
              onChange={handleChange}
              error={errors.name}
              helperText={errors.name}
              required
            />
          </Grid>
          <Grid xs={12} item>
            <MuiTelInput
              fullWidth
              defaultCountry="US"
              value={organization?.telephone || ""}
              label="Telephone"
              forceCallingCode
              onChange={(value) =>
                setOrganization((prev) => ({
                  ...prev,
                  telephone: value,
                }))
              }
            />
          </Grid>
          <Grid xs={12} item>
            <GoogleAddressSelect
              address={organization?.address}
              setData={setOrganization}
              required={true}
              errors={errors}
            />
          </Grid>
          <Grid xs={12} item>
            <TextField
              fullWidth
              label="Medical Provider Number"
              name="medicareProviderNumber"
              type="number"
              value={organization?.medicareProviderNumber}
              variant="outlined"
              onChange={handleChange}
            />
          </Grid>
          <Grid xs={12} item>
            <TextField
              fullWidth
              value={organization?.notes}
              multiline
              rows={2}
              name="notes"
              label="Notes"
              variant="outlined"
              onChange={handleChange}
              sx={{
                height: "auto",
                "& .MuiInputBase-root": { height: "auto" },
              }}
            />
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default CreateOrganization;
